// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reaction-details .right-sidebar-header {
  padding-bottom: 32px;
}
/* ReactionDetails-specific styles (extends RightSidebar) */
.reaction-details-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 16px;
  border-bottom: 1px solid #e0e0e0;
}

.reaction-filter-button {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px 16px;
  border: 1px solid #ddd;
  border-radius: 20px;
  background: white;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.reaction-filter-button:hover {
  background-color: #f0f0f0;
  border-color: #ccc;
}

.reaction-filter-button.active {
  background-color: #e0e0e0;
  border-color: #ccc;
  color: black;
}

.reaction-filter-button.active:hover {
  background-color: #d0d0d0;
  border-color: #bbb;
}

.reaction-details-content {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
}

.reaction-details-list {
  padding: 8px 0;
  overflow: hidden;
}

.reaction-details-item {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  transition: background-color 0.2s ease;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  line-height: 16px;
  cursor: pointer;
  min-width: 0;
  box-sizing: border-box;
}

.reaction-details-item:hover {
  background-color: #f8f9fa;
}

.reaction-details-avatar {
  width: 36px;
  height: 36px;
  margin-right: 12px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  position: relative;
}

.reaction-details-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.reaction-details-presence-indicator {
  position: absolute;
  bottom: 2px;
  right: 2px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 2px solid white;
  background-color: #cccccc;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
}

.reaction-details-name {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
  margin-right: 8px;
}

.reaction-details-name-row {
  display: flex;
  align-items: center;
  min-width: 0;
}

.reaction-details-mxid {
  font-size: 12px;
  color: #666;
  margin-top: 2px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
}

.reaction-details-name-text {
  font-size: 16px;
  font-weight: 400;
  color: rgb(0, 0, 0);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: fit-content;
}

.reaction-details-you-label {
  flex-shrink: 0;
  color: #666;
  font-weight: 400;
  font-size: 16px;
  margin-left: 4px;
}

.reaction-details-emoji {
  font-size: 32px;
  flex-shrink: 0;
}

.reaction-details-empty {
  text-align: center;
  color: black;
  font-style: italic;
  padding: 40px 20px;
}`, "",{"version":3,"sources":["webpack://./src/components/Page/Conversations/ChatView/ReactionDetails.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;AACA,2DAA2D;AAC3D;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,sCAAsC;EACtC,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB","sourcesContent":[".reaction-details .right-sidebar-header {\n  padding-bottom: 32px;\n}\n/* ReactionDetails-specific styles (extends RightSidebar) */\n.reaction-details-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 16px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.reaction-filter-button {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 8px 16px;\n  border: 1px solid #ddd;\n  border-radius: 20px;\n  background: white;\n  font-size: 16px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.reaction-filter-button:hover {\n  background-color: #f0f0f0;\n  border-color: #ccc;\n}\n\n.reaction-filter-button.active {\n  background-color: #e0e0e0;\n  border-color: #ccc;\n  color: black;\n}\n\n.reaction-filter-button.active:hover {\n  background-color: #d0d0d0;\n  border-color: #bbb;\n}\n\n.reaction-details-content {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.reaction-details-list {\n  padding: 8px 0;\n  overflow: hidden;\n}\n\n.reaction-details-item {\n  display: flex;\n  align-items: center;\n  padding: 8px 16px;\n  transition: background-color 0.2s ease;\n  font-family: Roboto, sans-serif;\n  font-size: 16px;\n  line-height: 16px;\n  cursor: pointer;\n  min-width: 0;\n  box-sizing: border-box;\n}\n\n.reaction-details-item:hover {\n  background-color: #f8f9fa;\n}\n\n.reaction-details-avatar {\n  width: 36px;\n  height: 36px;\n  margin-right: 12px;\n  border-radius: 50%;\n  overflow: hidden;\n  flex-shrink: 0;\n  position: relative;\n}\n\n.reaction-details-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.reaction-details-presence-indicator {\n  position: absolute;\n  bottom: 2px;\n  right: 2px;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  border: 2px solid white;\n  background-color: #cccccc;\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);\n}\n\n.reaction-details-name {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-width: 0;\n  margin-right: 8px;\n}\n\n.reaction-details-name-row {\n  display: flex;\n  align-items: center;\n  min-width: 0;\n}\n\n.reaction-details-mxid {\n  font-size: 12px;\n  color: #666;\n  margin-top: 2px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  width: 100%;\n}\n\n.reaction-details-name-text {\n  font-size: 16px;\n  font-weight: 400;\n  color: rgb(0, 0, 0);\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  max-width: fit-content;\n}\n\n.reaction-details-you-label {\n  flex-shrink: 0;\n  color: #666;\n  font-weight: 400;\n  font-size: 16px;\n  margin-left: 4px;\n}\n\n.reaction-details-emoji {\n  font-size: 32px;\n  flex-shrink: 0;\n}\n\n.reaction-details-empty {\n  text-align: center;\n  color: black;\n  font-style: italic;\n  padding: 40px 20px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
